/* Copyright (c) 2020-present CloudIO Inc */

import { Platform } from '../../platform/Platform';
import { ComponentManagerFn } from '../../registry/Component.type';
import { ItemType } from '../../registry/ComponentRegistry';
import { baseComponentManager } from '../../registry/Components';
import { defaultValue } from './D3Chart';
import { helpRenders } from './D3Chart_Help';

const D3ChartManager: ComponentManagerFn<'D3Chart'> = (platform: Platform) => {
  return {
    ...baseComponentManager<'D3Chart'>(platform, 'D3Chart'),
    type: 'D3Chart',
    name: 'D3 Chart',
    isChildAllowed: (page, item, childType) =>
      (['TriggerOnClick'] as ItemType[]).includes(childType),
    defaultValue,
    props: {
      d3Script: {
        label: 'D3 Script',
        type: 'typescript',
        compileOnChange: true,
        defaultScript: `import { parseISO } from 'date-fns';
import * as d3 from 'd3';
import { D3Props, d3uid } from 'cloudio';

const TOOLTIP_ON_TOP = true;

// mount function is called when the D3 Chart item is mounted
// do your initailization here. This function is called only once
// when the D3 Chart item is mounted. if the user navigates away
// from the page and comes back, this function will be called again
function mount(props: D3Props) {
  console.log('mount', props);
}

// render function is called whenever the props passed to the D3 Chart item changes
// e.g. when the dataset or the width or height of the D3 Chart item changes
function render(props: D3Props) {
  console.log('render', props);
  const {
    dataset, // this is the dataset passed to the D3 Chart item from the parent data store reference defined above the D3 Chart item
    svg, // this is the root svg element of the D3 Chart item
    width, // this is the width of the D3 Chart item
    height, // this is the height of the D3 Chart item
    onClickTrigger, // this is the callback function to invoke any On Click Triggers defined inside the D3 Chart item
    tooltipRef, // the tooltip div element
    rootRef, // the root div element
    theme, // the material-ui theme object
  } = props;
}

// mount function is called when the D3 Chart item is unmounted
// use this to clean up any work done in the mount function
// this function will be called when the D3 Chart item is unmounted
// due to the user navigating away from the page or the D3 Chart item being removed from the dashboard
function unmount(props: D3Props) {
  console.log('unmount', props);
}

export default { render, mount, unmount };
`,
        helpText:
          'Refer https://github.com/cloudio-saas/d3 for build the chart locally',
      },
      noDataFoundMessage: {
        label: 'No Data Found Message',
        type: 'string',
      },
    },
    category: 'Dashboard',
    icon: { iconName: 'chart-line' },
    description: 'Scriptable D3 Chart',
    helpRenders,
  };
};

export default D3ChartManager;
